import { segmentClient } from '@/util/analytics';

export function trackEvent(...args: Parameters<typeof segmentClient.track>) {
  return segmentClient.track(...args);
}
